import { motion } from "framer-motion";

export const ActivePositionsPanel = ({ positions = [] }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.15 }}
      className="panel lg:col-span-7 flex flex-col min-h-[280px]"
      data-testid="active-positions-panel"
    >
      <div className="panel-header">
        <h3 className="font-display text-sm font-bold uppercase tracking-tight">
          Active Positions
        </h3>
        <span className="label-micro">{positions.length} open · Supabase</span>
      </div>

      {positions.length === 0 ? (
        <p className="p-4 text-sm text-text-secondary font-mono">No rows in active_positions.</p>
      ) : (
        <div className="overflow-auto flex-1">
          <table className="w-full text-[11px] font-mono">
            <thead>
              <tr className="text-left text-text-secondary border-b border-border">
                <Th>Ticker</Th>
                <Th align="right">Lots</Th>
                <Th align="right">Avg buy</Th>
                <Th align="right">Last</Th>
                <Th align="right">Unrealized</Th>
                <Th align="right">Alloc %</Th>
              </tr>
            </thead>
            <tbody>
              {positions.map((p) => (
                <tr key={p.ticker} className="border-b border-border/60 hover:bg-surface-muted">
                  <Td className="font-semibold">{p.ticker}</Td>
                  <Td align="right" className="num">{p.lot_held}</Td>
                  <Td align="right" className="num">{Number(p.avg_buy_price).toLocaleString("id-ID")}</Td>
                  <Td align="right" className="num">{Number(p.current_price).toLocaleString("id-ID")}</Td>
                  <Td
                    align="right"
                    className={`num ${Number(p.unrealized_pnl_pct) >= 0 ? "text-positive" : "text-magenta"}`}
                  >
                    {p.unrealized_pnl_pct != null ? `${Number(p.unrealized_pnl_pct).toFixed(2)}%` : "—"}
                  </Td>
                  <Td align="right" className="num">{p.allocated_pct}%</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </motion.div>
  );
};

const Th = ({ children, align = "left" }) => (
  <th className={`px-3 py-2 text-[10px] uppercase tracking-[0.18em] ${align === "right" ? "text-right" : "text-left"}`}>
    {children}
  </th>
);
const Td = ({ children, align = "left", className = "" }) => (
  <td className={`px-3 py-2 ${align === "right" ? "text-right" : "text-left"} ${className}`}>{children}</td>
);

export default ActivePositionsPanel;
